import { Routes } from "react-router-dom";
import Home from "./index";
function AppRoutes() {
  return (
    <Routes>
      {/* <Route path="/" element={<Accueil />} />
        <Route path="/a-propos" element={<About />} />
        <Route path="/pages-sponsorises" element={<Sponsorises />} />
        <Route path="/connexion" element={<Connexion />} />
        <Route path="/inscription" element={<Inscription />} />
        <Route path="/annuaire-producteurs" element={<AnnuaireProducteurs />} />
        <Route path="/conditions-generales" element={<ConditionsGenerales />} />
        <Route path="/temoignages" element={<Temoignages />} /> */}
    </Routes>
  );
}

function RoutesConfig() {
  return (
    <div className="flex flex-col justify-between">
      <Home />
      <AppRoutes />
    </div>
  );
}

export default RoutesConfig;
